import { Component, OnInit, ViewContainerRef } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { AuthService } from '../service/auth.service';
import { AtadoInfoComponent } from '../components/atado-info/atado-info.component';

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
        path: '/dashboard',
        title: 'Főoldal',
        type: 'link',
        icontype: 'dashboard'
    }, {
        path: '/ngs/atado',
        title: 'Átadók',
        type: 'sub',
        icontype: 'apps',
        collapse: 'components',
        children: [
            {
                path: 'kalmanhaza',
                title: 'Kálmánháza',
                ab: 'Kál'
            },
            {
                path: 'kotaj',
                title: 'Kótaj',
                ab: 'Kót',
            },
            {
                path: 'nadudvar',
                title: 'Nádudvar',
                ab: 'Nád'
            },
            {
                path: 'bodonhat',
                title: 'Bödönhát',
                ab: 'Böd'
            }
        ]
    },
    {
        path: '/ngs/napiallokalas',
        title: 'Napi Allokálás',
        type: 'sub',
        icontype: 'book',
        collapse: 'allocations',
        children: [
            {
                path: 'bodonhat',
                title: 'Bödönhát',
                ab: 'Böd'
            },
            {
                path: 'nadudvar',
                title: 'Nádudvar',
                ab: 'Nád'
            }
        ]
    },
    {
        path: '/ngs/haviallokalas',
        title: 'Havi Allokálás',
        type: 'sub',
        icontype: 'calendar_today',
        collapse: 'monthallocations',
        children: [
            {
                path: 'nadudvar',
                title: 'Nádudvar',
                ab: 'Nád'
            }
        ]
    },
    {
        path: '/ngs',
        title: 'Óracsúcs',
        type: 'sub',
        icontype: 'insert_chart_outlined',
        collapse: 'oracsucs',
        children: [
            {
                path: 'lekotesek',
                title: 'Lekötések',
                ab: 'Lek'
            },
            {
                path: 'vasarolt',
                title: 'Vásárolt',
                ab: 'Vás',
            },
            {
                path: 'factors',
                title: 'Tényezők',
                ab: 'Tény'
            },
            {
                path: 'fogyasztas',
                title: 'Fogyasztás',
                ab: 'Fogy'
            }
        ]
    },
    {
        path: '/ngs/lekerdezesek',
        title: 'Lekérdezések',
        type: 'link',
        icontype: 'question_answer'
    },
];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];

    currentUserInfo = null;

    constructor(private authService: AuthService) {
        this.authService.getUserIdToken().subscribe(token => {
            console.debug("Log in successfull - 2");
        });
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
    }
    updatePS(): void  {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            let ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}



// WEBPACK FOOTER //
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/sidebar/sidebar.component.ts